import { gql } from '@apollo/client'
import { workOrderRemarksActivityFragment, workOrderTasksFragment } from './graphql'
import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import type { UpdateWorkOrderTaskArgs, WorkOrder } from '@ztechapps/common.contract'

/**
 * This will update the project task that is related to the work order
 */

export const updateWorkOrderTaskQuery = gql`
  mutation updateWorkOrderTask($input: UpdateWorkOrderTaskArgs!) {
    updateWorkOrderTask(input: $input) {
      _id
      progressNow
      progressMax
      status
      miscellaneousCost
      totalOperationsCost
      subAssemblyCost
      totalManufactureCost
      tasks {
        ...workOrderTasksFragment
      }
    }
  }
  ${workOrderTasksFragment}
  ${workOrderRemarksActivityFragment}
`

export const useUpdateWorkOrderTask = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, UpdateWorkOrderTaskArgs> => {
  query = query ?? updateWorkOrderTaskQuery

  return useActionMutation({
    query,
    ...props,
  })
}
